/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Resource_Allocations_Scope_CurrentInputs */

const en_admin_resources_resource_allocations_scope_current = /** @type {(inputs: Admin_Resources_Resource_Allocations_Scope_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current`)
};

const de_admin_resources_resource_allocations_scope_current = /** @type {(inputs: Admin_Resources_Resource_Allocations_Scope_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktuell`)
};

const es_admin_resources_resource_allocations_scope_current = /** @type {(inputs: Admin_Resources_Resource_Allocations_Scope_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actuales`)
};

const fr_admin_resources_resource_allocations_scope_current = /** @type {(inputs: Admin_Resources_Resource_Allocations_Scope_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En cours`)
};

/** @type {(inputs: Admin_Resources_Resource_Allocations_Scope_CurrentInputs) => LocalizedString} */
const it_admin_resources_resource_allocations_scope_current = en_admin_resources_resource_allocations_scope_current;

/** @type {(inputs: Admin_Resources_Resource_Allocations_Scope_CurrentInputs) => LocalizedString} */
const pt_br2_admin_resources_resource_allocations_scope_current = en_admin_resources_resource_allocations_scope_current;

/** @type {(inputs: Admin_Resources_Resource_Allocations_Scope_CurrentInputs) => LocalizedString} */
const pl_admin_resources_resource_allocations_scope_current = en_admin_resources_resource_allocations_scope_current;

/** @type {(inputs: Admin_Resources_Resource_Allocations_Scope_CurrentInputs) => LocalizedString} */
const hu_admin_resources_resource_allocations_scope_current = en_admin_resources_resource_allocations_scope_current;

/** @type {(inputs: Admin_Resources_Resource_Allocations_Scope_CurrentInputs) => LocalizedString} */
const ro_admin_resources_resource_allocations_scope_current = en_admin_resources_resource_allocations_scope_current;

/**
* | output |
* | --- |
* | "Current" |
*
* @param {Admin_Resources_Resource_Allocations_Scope_CurrentInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_resource_allocations_scope_current = /** @type {((inputs?: Admin_Resources_Resource_Allocations_Scope_CurrentInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Resource_Allocations_Scope_CurrentInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_resource_allocations_scope_current(inputs)
	if (locale === "de") return de_admin_resources_resource_allocations_scope_current(inputs)
	if (locale === "es") return es_admin_resources_resource_allocations_scope_current(inputs)
	if (locale === "fr") return fr_admin_resources_resource_allocations_scope_current(inputs)
	if (locale === "it") return it_admin_resources_resource_allocations_scope_current(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_resource_allocations_scope_current(inputs)
	if (locale === "pl") return pl_admin_resources_resource_allocations_scope_current(inputs)
	if (locale === "hu") return hu_admin_resources_resource_allocations_scope_current(inputs)
	return ro_admin_resources_resource_allocations_scope_current(inputs)
});
export { admin_resources_resource_allocations_scope_current as "admin.resources.resource_allocations.scope_current" }